import { useState } from 'react';
/**
 * Text-input state seeded from a server value, re-seeding on background refetch only while the
 * user hasn't started editing. Adjusting state during render (React's documented pattern for
 * "state that depends on a prop/query result") avoids the extra render an effect-based reset
 * would cause. Shared by the editable numeric-cap fields in AgentCard and SettingsPanel.
 */
export function useSeededInput(savedValue, isValid) {
    const [input, setInput] = useState(savedValue);
    const [dirty, setDirty] = useState(false);
    const [seededValue, setSeededValue] = useState(savedValue);
    if (!dirty && savedValue !== seededValue) {
        setSeededValue(savedValue);
        setInput(savedValue);
    }
    const valid = isValid(input);
    const unchanged = input === savedValue;
    function markDirty(value) {
        setDirty(true);
        setInput(value);
    }
    function markSaved() {
        setDirty(false);
    }
    return { input, setInput: markDirty, valid, unchanged, markSaved };
}
